import { FC } from "react";

import Box from "@mui/material/Box";

import { DashboardIcon } from "@/dashboard-design-system/Icon/DashboardIcon";
import { Error, Success, Info, Warning } from "@/icons/outlined";
import { IconElement } from "@/icons/types";

export const iconWithBackgroundVibeOptions = ["brand", "danger", "warning", "positive", "neutral"] as const;
export type IconWithBackgroundVibe = (typeof iconWithBackgroundVibeOptions)[number];

type IconWithBackgroundProps = {
  vibe: IconWithBackgroundVibe;
  icon?: IconElement;
};

export const IconWithBackground: FC<IconWithBackgroundProps> = ({ vibe, icon: iconProp }) => {
  const icon = (() => {
    if (iconProp) {
      return iconProp;
    }

    switch (vibe) {
      case "brand":
        return <Info />;
      case "danger":
        return <Error />;
      case "warning":
        return <Warning />;
      case "positive":
        return <Success />;
      default:
        return undefined;
    }
  })();

  if (!icon) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        padding: 0.75,
        background: theme.palette.surface[vibe].quiet,
        display: "inline-flex",
        borderRadius: 1,
      })}
    >
      <DashboardIcon vibe={`text-${vibe}-quiet`} size="large">
        {icon}
      </DashboardIcon>
    </Box>
  );
};
